export default {
  "date-picker-label": "_date-picker-label_vytb6b"
};